import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Container,
  FormLabel,
  Heading,
  SimpleGrid,
  Stack,
  Text,
} from "@chakra-ui/react";

import React, { useEffect, useState } from "react";
import BreadcrumbBox from "../../theme/components/breadcrumb";
import { GET_BREADCRUMB_ROUTES } from "../../core/utils/navbar-items";
import { MENU_NAMES } from "../../core/utils/constants";
import { Form, Formik } from "formik";
import * as yup from "yup";
import TextInput from "../../theme/components/input/text-input";
import { colors } from "../../theme/styles/colors";
import { useLocation, useNavigate } from "react-router-dom";
import SCHEMA_VALIDATOR from "../../core/utils/schema-validator";
import { GRP_MENU_WITH_CHILD, getById } from "../../core/utils/common-function";
import api from "../../core/api";
import SwitchInput from "../../theme/components/input/switch-input";
import { SuccessAlert } from "../../core/utils/common-sweet-alert";

const EditRole = () => {
  const params = useLocation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [roleId] = useState(params.state.id);
  const [initialState, setInitialState] = useState({
    isActive: false,
    name: "",
    permissions: [],
  });

  const activeCard = {
    borderRadius: "10px",
    fontWeight: "600",
    fontSize: "12px",
    overflow: "hidden",
    columns: { base: "1", sm: "1", md: "2", lg: "2" },
    backgroundColor: "rgb(255 255 255)",
    paddingBottom: "0px",
    marginBottom: "10px",
    padding: "10px",
    boxShadow: "0px 0px 30px 0px #d5d5d552",
  };

  const getSingleRecord = async (allpermissions) => {
    try {
      if (roleId) {
        const record = (await getById("Role", roleId)).data;
        if (record.permissions && record.permissions.length == 0) {
          setInitialState({
            ...initialState,
            ...record,
            permissions: GRP_MENU_WITH_CHILD(allpermissions),
          });
          return;
        }

        const moduleId = record.permissions.map((item) => item.moduleId);
        let finalArr = [];
        const uArray = allpermissions.reduce((previous, current, index) => {
          if (moduleId.includes(current.moduleId)) {
            const moduleIndex = moduleId.findIndex(
              (item) => item === current.moduleId
            );
            finalArr[moduleIndex] = record.permissions[moduleIndex];
            return;
          }
          finalArr[index] = current;
        }, []);

        setInitialState({
          ...initialState,
          ...record,
          permissions: GRP_MENU_WITH_CHILD(finalArr),
        });
      }
    } catch (error) {}
  };

  const getAllRecords = () => {
    api
      .post("/Role/getAllPermissionModule")
      .then((res) => {
        getSingleRecord(res.data.data);
      })
      .catch((err) => {
        console.log(err, "error");
      });
  };

  const { STRING_VALIDATOR } = SCHEMA_VALIDATOR;
  const validationSchema = yup.object({
    name: STRING_VALIDATOR,
  });

  useEffect(() => {
    getAllRecords();
  }, []);

  return (
    <Container maxW="container.xll" padding={"13px "}>
      <Box>
        <BreadcrumbBox route={GET_BREADCRUMB_ROUTES(MENU_NAMES.EDIT_ROLE)} />
      </Box>
      <Formik
        validationSchema={validationSchema}
        initialValues={initialState}
        enableReinitialize={true}
        onSubmit={(values) => {
          let finArr = [];
          values.permissions.map((parent) =>
            parent.map((item) => {
              finArr.push(item);
            })
          );
          values.permissions = finArr;
          api
            .put(`Role/replace`, { ...values })
            .then((res) => {
              SuccessAlert("Record updated successfully");
              navigate(params.state.navigateUrl, {
                state: {
                  currentPage:params.state.currentPage,
                  currentPageSize:params.state.currentPageSize
                },
              });
            })
            .catch((err) => {
              console.log(err, "err");
            });
        }}
      >
        {({ handleSubmit, handleChange, values, errors, setFieldValue }) => (
          <Form
            noValidate={true}
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit();
            }}
          >
            <Box display={"flex"} justifyContent="space-between">
              <Box>
                <Heading variant={"h1"} marginBottom={"13px"}>
                  Edit Role
                </Heading>
              </Box>
              <Box
                display={"flex"}
                alignItems={"center"}
                gap={"10px"}
                marginBottom={"13px"}
              >
                <Button
                  variant={"warning"}
                  onClick={() => {
                    navigate("/general/role", {
                      state: {
                        currentPage:params.state.currentPage,
                        currentPageSize:params.state.currentPageSize
                      },
                    });
                  }}
                >
                  Discard
                </Button>
                <Button variant={"primary"} type="submit">
                  {isLoading ? (
                    <CircularProgress
                      isIndeterminate
                      size="24px"
                      color={colors.white}
                    />
                  ) : (
                    "Submit"
                  )}
                </Button>
              </Box>
            </Box>
            <Box
              display={"flex"}
              gap={"13px"}
              borderRadius={"10px"}
              flexDirection={"column"}
            >
              <Box
                padding={"13px"}
                borderRadius={"10px"}
                border={"1px solid #e6e6e6"}
              >
                <SimpleGrid
                  columns={{ base: "1", lg: "1", md: "3", lg: "3" }}
                  spacingX="30px"
                  spacingY="0px"
                >
                  <TextInput
                    type="text"
                    isRequired={true}
                    name="name"
                    value={values.name}
                    label={{
                      text: "Role Name",
                      colors: errors.name ? "red !important" : "",
                      variant: errors.name ? "errored" : "",
                    }}
                    onChange={handleChange}
                    placeholder={""}
                    variant={errors.name ? "errored" : "flushed"}
                    isReadOnly={isLoading}
                  />
                  <SwitchInput
                    placeholder={""}
                    isRequired={true}
                    isReadOnly={false}
                    value={values.isActive}
                    name="isActive"
                    variant={errors.isActive ? "errored" : "flushed"}
                    label={{
                      text: "Active",
                      colors: errors.isActive ? "red !important" : "",
                      variant: errors.isActive ? "errored" : "",
                      fontSize: "12px",
                    }}
                    formControl={{ id: "isActive" }}
                    onChange={handleChange}
                  />
                </SimpleGrid>

                <Box as="span" flex="1" textAlign="left" fontWeight={"600"}>
                  Menu Permissions
                </Box>
                <Box>
                  <Stack
                    spacing={5}
                    direction="row"
                    padding={"0px 0px 10px 0px"}
                    display={"flex"}
                    flexDirection={"column"}
                    gap={"5px"}
                  >
                    <FormLabel
                      fontSize={"14px"}
                      fontWeight={"500"}
                      marginLeft={"7px"}
                      color={"#646262"}
                    ></FormLabel>
                    <Checkbox
                      __css={{
                        "& .chakra-checkbox__control": {
                          background: "#e2e8f0",
                        },
                      }}
                      width={"10%"}
                      iconSize="30px"
                      marginLeft={"8px"}
                      size={"lg"}
                      display={"flex"}
                      colorScheme="yellow"
                      onChange={(e) => {
                        const adminPermissions = values.permissions?.map(
                          (childrens) => {
                            return childrens.map((child) => ({
                              ...child,
                              hasCreate: e.target.checked,
                              hasEdit: e.target.checked,
                              hasDelete: e.target.checked,
                              hasView: e.target.checked,
                            }));
                          }
                        );

                        setInitialState({
                          ...values,
                          permissions: adminPermissions,
                        });
                      }}
                    >
                      <Text fontSize={14} color={"#646262"}>
                        Select All
                      </Text>
                    </Checkbox>
                  </Stack>
                  <SimpleGrid
                    columns={{ base: "1", lg: "1", md: "2", lg: "2" }}
                    spacingX="10px"
                    spacingY="0px"
                  >
                    {values?.permissions.map((childrens, index) => {
                      return (
                        <Box {...activeCard} key={index}>
                          {childrens.map((item, childIndex) => {
                            return (
                              <Box
                                w="100%"
                                justifyContent="space-between"
                                display="flex"
                                padding={2}
                                key={childIndex}
                              >
                                <FormLabel
                                  fontSize={"13px"}
                                  fontWeight={"400"}
                                  color={"black"}
                                >
                                  {item?.name}
                                </FormLabel>
                                <Box
                                  w={"60%"}
                                  display="flex"
                                  justifyContent="space-between"
                                >
                                  <Checkbox
                                    __css={{
                                      "& .chakra-checkbox__control": {
                                        background: "#e2e8f0",
                                      },
                                    }}
                                    display={"flex"}
                                    size="lg"
                                    onChange={() => {
                                      const parent = values.permissions[index];
                                      const pChild = parent[childIndex];
                                      pChild.hasView = !pChild.hasView;
                                      pChild.hasCreate = pChild.hasView;
                                      pChild.hasDelete = pChild.hasView;
                                      pChild.hasEdit = pChild.hasView;
                                      setFieldValue(
                                        "permissions",
                                        values.permissions
                                      );
                                    }}
                                    colorScheme="yellow"
                                    isDisabled={false}
                                    isChecked={item?.hasView}
                                  >
                                    <Text fontSize={13} color={"#646262"}>
                                      View
                                    </Text>
                                  </Checkbox>
                                  <Checkbox
                                    __css={{
                                      "& .chakra-checkbox__control": {
                                        background: "#e2e8f0",
                                      },
                                    }}
                                    isDisabled={false}
                                    display={"flex"}
                                    colorScheme="yellow"
                                    size="lg"
                                    isChecked={item?.hasCreate}
                                    onChange={() => {
                                      const parent = values.permissions[index];
                                      const pChild = parent[childIndex];
                                      pChild.hasCreate = !pChild.hasCreate;
                                      if (pChild.hasCreate) {
                                        pChild.hasView = !pChild.hasView;
                                      }
                                      setFieldValue(
                                        "permissions",
                                        values.permissions
                                      );
                                    }}
                                  >
                                    <Text fontSize={13} color={"#646262"}>
                                      Create
                                    </Text>
                                  </Checkbox>
                                  <Checkbox
                                    __css={{
                                      "& .chakra-checkbox__control": {
                                        background: "#e2e8f0",
                                      },
                                    }}
                                    display={"flex"}
                                    size="lg"
                                    colorScheme="yellow"
                                    isDisabled={false}
                                    isChecked={item?.hasEdit}
                                    onChange={() => {
                                      const parent = values.permissions[index];
                                      const pChild = parent[childIndex];
                                      pChild.hasEdit = !pChild.hasEdit;
                                      if (pChild.hasEdit) {
                                        pChild.hasView = !pChild.hasEdit;
                                      }
                                      setFieldValue(
                                        "permissions",
                                        values.permissions
                                      );
                                    }}
                                  >
                                    <Text fontSize={13} color={"#646262"}>
                                      Edit
                                    </Text>
                                  </Checkbox>
                                  <Checkbox
                                    __css={{
                                      "& .chakra-checkbox__control": {
                                        background: "#e2e8f0",
                                      },
                                    }}
                                    display={"flex"}
                                    size="lg"
                                    colorScheme="yellow"
                                    isDisabled={false}
                                    isChecked={item?.hasDelete}
                                    onChange={() => {
                                      const parent = values.permissions[index];
                                      const pChild = parent[childIndex];
                                      pChild.hasDelete = !pChild.hasDelete;
                                      if (pChild.hasDelete) {
                                        pChild.hasView = !pChild.hasDelete;
                                      }
                                      setFieldValue(
                                        "permissions",
                                        values.permissions
                                      );
                                    }}
                                  >
                                    <Text fontSize={13} color={"#646262"}>
                                      Delete
                                    </Text>
                                  </Checkbox>
                                </Box>
                              </Box>
                            );
                          })}
                        </Box>
                      );
                    })}
                  </SimpleGrid>
                </Box>
              </Box>
            </Box>
          </Form>
        )}
      </Formik>
    </Container>
  );
};

export default EditRole;
